import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
  Tabs,
  Tab,
  Grid,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
// components

import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";

import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
// ----------------------------------------------------------------------

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1, paddingTop: 3 }}>{children}</Box>}
    </div>
  );
}
const teams = [
  { name: "ANAHEIM DUCKS", id: 1 },
  { name: "BOSTON BRUINS", id: 2 },
  { name: "BUFFALO SABRES", id: 3 },
  { name: "CALGARY FLAMES", id: 4 },
  { name: "CAROLINA HURRICANES", id: 5 },
  { name: "CHICAGO BLACKHAWKS", id: 6 },
  { name: "COLORADO AVALANCHE", id: 7 },
  { name: "COLUMBUS BLUE JACKETS", id: 8 },
  { name: "DALLAS STARS", id: 9 },
  { name: "DETROIT RED WINGS", id: 10 },
  { name: "EDMONTON OILERS", id: 11 },
  { name: "FLORIDA PANTHERS", id: 12 },
  { name: "LOS ANGELES KINGS", id: 13 },
  { name: "MINNESOTA WILD", id: 14 },
  { name: "MONTRÉAL CANADIENS", id: 15 },
  { name: "NASHVILLE PREDATORS", id: 16 },
  { name: "NEW JERSEY DEVILS", id: 17 },
  { name: "NEW YORK ISLANDERS", id: 18 },
  { name: "NEW YORK RANGERS", id: 19 },
  { name: "OTTAWA SENATORS", id: 20 },
  { name: "PHILADELPHIA FLYERS", id: 21 },
  { name: "PITTSBURGH PENGUINS", id: 22 },
  { name: "SAN JOSE SHARKS", id: 23 },
  { name: "ST. LOUIS BLUES", id: 24 },
  { name: "TAMPA BAY LIGHTNING", id: 25 },
  { name: "TORONTO MAPLE LEAFS", id: 26 },
  { name: "VANCOUVER CANUCKS", id: 27 },
  { name: "WASHINGTON CAPITALS", id: 28 },
  { name: "WINNIPEG JETS", id: 29 },
  { name: "ARIZONA COYOTES", id: 30 },
  { name: "VEGAS GOLDEN KNIGHTS", id: 31 },
  { name: "SEATTLE KRAKEN", id: 32 },
];
export default function PlayersStatsPage() {
  const [loading, setLoading] = useState(false);
  const [matchStatsRows, setMatchStatsRows] = useState(null);
  const [teamStatsRows, setTeamStatsRows] = useState(null);
  const [match, setMatch] = useState(null);
  const [matches, setMatches] = useState([]);
  const [team, setTeam] = useState(null);
  const [value, setValue] = useState(0);

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_FEED_BASE_URL}/feeds/nhl/fixtures?token=${process.env.REACT_APP_FEED_TOKEN}`
      )
      .then(function (response) {
        setMatches(response.data);
      });
  }, []);

  const handleChangeTabs = (event, newValue) => {
    setValue(newValue);
  };

  const handleTeamChange = (event) => {
    setTeam(event.target.value);
    axios
      .get(
        `${process.env.REACT_APP_FEED_BASE_URL}/feeds/nhl/team-players-stats/${event.target.value}?token=${process.env.REACT_APP_FEED_TOKEN}`
      )
      .then(function (response) {
        setTeamStatsRows(response.data.data);
      });
  };
  const handleMatchChange = (event) => {
    setMatch(event.target.value);
    axios
      .get(
        `${process.env.REACT_APP_FEED_BASE_URL}/feeds/nhl/match-stats/${event.target.value}?token=${process.env.REACT_APP_FEED_TOKEN}`
      )
      .then(function (response) {
        setMatchStatsRows(response.data[0].player_stats);
      });
  };
  return (
    <>
      <Helmet>
        <title> Players Stats Page </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Players Stats
          </Typography>
        </Stack>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChangeTabs}
            aria-label="basic tabs example"
          >
            <Tab label="Avg Stats" {...a11yProps(0)} />
            <Tab label="Match Stats" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl sx={{ m: 1, minWidth: 620 }} size="small">
                <InputLabel id="demo-simple-select-label">Team</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={team}
                  label="Team"
                  onChange={handleTeamChange}
                >
                  {teams.map((team) => (
                    <MenuItem value={team.id} key={team.id}>
                      {team.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Card>
            {teamStatsRows === null || loading ? (
              <Box
                sx={{ display: "flex", justifyContent: "center" }}
                style={{ padding: 20 }}
              >
                Choose Team
              </Box>
            ) : (
              <Scrollbar>
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>#</TableCell>
                        <TableCell>Player Name</TableCell>
                        <TableCell>Avg. Max Speed</TableCell>
                        <TableCell>Avg. Distnace</TableCell>
                        <TableCell>Avg. Avg. Speed</TableCell>
                        <TableCell>Avg. Shot Speed</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {teamStatsRows.map((row, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell component="th" scope="row">
                            {index + 1}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {row.first_name} {row.last_name}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {row.avg_max_speed}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {row.avg_distance_total}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {row.avg_avg_speed}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {row.avg_shot_speed}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Scrollbar>
            )}
          </Card>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl sx={{ m: 1, minWidth: 620 }} size="small">
                <InputLabel id="demo-simple-select-label">Match</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={match}
                  label="Match"
                  onChange={handleMatchChange}
                >
                  {matches.map((match) => (
                    <MenuItem value={match.id} key={match.id}>
                      {match.home_team.name} vs {match.away_team.name} |{" "}
                      {match.start_utc}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Card>
            {matchStatsRows === null || loading ? (
              <Box
                sx={{ display: "flex", justifyContent: "center" }}
                style={{ padding: 20 }}
              >
                Choose Match
              </Box>
            ) : (
              <Scrollbar>
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>#</TableCell>
                        <TableCell>Player Name</TableCell>
                        <TableCell>Max Speed</TableCell>
                        <TableCell>Distnace</TableCell>
                        <TableCell>Avg. Speed</TableCell>
                        <TableCell>Shot Speed</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {matchStatsRows.map((row, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell component="th" scope="row">
                            {index + 1}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {row.player.first_name} {row.player.last_name}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {row.max_speed}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {row.distance_total}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {row.avg_speed}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {row.shot_speed}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Scrollbar>
            )}
          </Card>
        </TabPanel>
      </Container>
    </>
  );
}
